<template>
  <q-editor
    ref="component"
    min-height="5rem"
    class="full-width"
    autofocus
    :toolbar="[
      ['bold', 'italic', 'strike', 'underline'],
      ['redo', 'undo'],
    ]"
    @keyup.enter.stop
  >
    <template v-for="(slot, index) of Object.keys($slots)" :key="index" #[slot]>
      <slot :name="slot"></slot>
    </template>
  </q-editor>
</template>

<script setup>
const component = ref(null);

defineExpose({
  component,
});
</script>

<style lang="scss" scoped>
.q-field {
  .q-editor {
    border-color: $neutral-50;

    &:focus-within,
    &:hover {
      border-color: $primary;
    }
  }

  &.q-field--error {
    .q-editor {
      border-color: none;
      outline: 2px solid $error-50;
    }
  }
}
</style>
